import { autoinject, Aurelia } from 'aurelia-framework';
import { Router } from 'aurelia-router';

const DEFAULT_VALIDATION_MESSAGE: string = "Fix errors below.";

@autoinject()
export class PageMessageService {

    errorMessage: string;
    infoMessage: string;

    //preserveMessageAfterNavigate allows setting page message in activate() and other lifecycle events that fire before navigation is complete.
    preserveMessageAfterNavigate: boolean;

    constructor(private aurelia: Aurelia, private router: Router) {
        (<any>this.aurelia).subscribe('router:navigation:complete', msg => this.onNavigationComplete(msg));
    }

    public setErrorMessage(message: string) {
        setTimeout(() => {
            this.errorMessage = message;
            this.preserveMessageAfterNavigate = this.router.isNavigating;

            setTimeout(function () {
                var $ = window['jQuery'];
                $('html, body').animate({
                    scrollTop: $('#page-message').offset().top - ($("nav.navbar").outerHeight() + 85)
                }, 'fast');
            });

        });
    }

    public setDefaultValidationMessage() {
        setTimeout(() => {
            this.setErrorMessage(DEFAULT_VALIDATION_MESSAGE);
            this.preserveMessageAfterNavigate = this.router.isNavigating;
        });
    }

    public setInfoMessage(message: string) {
        setTimeout(() => {
            this.infoMessage = message;
            this.preserveMessageAfterNavigate = this.router.isNavigating;
        });
    }

    public clear() {
        this.errorMessage = "";
        this.infoMessage = "";
    }


    onNavigationComplete(msg) {
        if (!msg.result.completed) {
            return;
        }

        //when route changes, clear the page message
        if (!this.preserveMessageAfterNavigate) {
            this.clear();
        }
        this.preserveMessageAfterNavigate = false;
    }

}